export default __webpack_public_path__ + "static/media/table_placeholder.c8e68a29.svg";